import { AbsShare } from "../AbsShare";
import { ShareLayer } from "../ShareLayer";
import { ShareNavigator } from "../ShareNavigator";
import { BtnShareTriggerWithShareLayer } from "./BtnShareTriggerWithShareLayer";


export class BtnShareTrigger{
    public ElTriggerBtn: HTMLButtonElement;
    btnShareTriggerWithShareLayer: BtnShareTriggerWithShareLayer | null = null;

    constructor( public shareInstance: AbsShare, public option: ShareOptionTriggerBtn){
        this.ElTriggerBtn = document.querySelector<HTMLButtonElement>(this.option.selector)!;

        // 1) 공유하기 버튼이 있는경우 공유하기 버튼을 누르면 open 메서드 실행
        this.#setTriggerBtn();

        // 2) 레이어 위치 옵션이 있으면 레이어는 공유하기 버튼 기준으로 일정 거리에 위치한다.
        const staticDistanceFromBtnToLayer = this.option.staticDistanceFromBtnToLayer;
        if(this.shareInstance instanceof ShareLayer && BtnShareTriggerWithShareLayer.canUse(this.shareInstance, staticDistanceFromBtnToLayer)){
            this.btnShareTriggerWithShareLayer = new BtnShareTriggerWithShareLayer(this.shareInstance.ElContainer, this.ElTriggerBtn, staticDistanceFromBtnToLayer)
        }
    }

    #setTriggerBtn(){
        this.#addEventTriggerBtn();
    }

    #addEventTriggerBtn(){
        // 공유하기 버튼 클릭
        this.ElTriggerBtn.addEventListener('click', this.onClick);
    }

    onClick = () => {
        this.shareInstance.toggle();
    }

    remove(){
        // 트리거 버튼에 붙은 이벤트 제거
        this.ElTriggerBtn.removeEventListener('click', this.onClick);

        // btnShareTriggerWithShareLayer 리사이즈 이벤트 제거
        this.btnShareTriggerWithShareLayer?.remove();
    }

    static canUse(btnShareTriggerOption: ShareOptionTriggerBtn){
        return btnShareTriggerOption.selector && document.querySelector(btnShareTriggerOption.selector) && true || false;
    }

}

